module.exports = __webpack_public_path__ + "img/Ktirio-Korinthos.e02c30d5.jpg";